<template>
  <div class="app-frame">
    <div class="inner-frame">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "app-frame",
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
